import { communitiesIds } from 'envs';
import electionsJson from '../elections.json';
import partiesSimulatorJson from '../partiesSimulator.json';

// Variables globales del proyecto

const electionsPathJson = 'elecciones-2023-mun-auto';

// export const electionsPath = 'comunidad-de-andalucia';

const communitiesExcluded = [
  communitiesIds.ANDALUCIA,
  communitiesIds.CASTILLA_Y_LEÓN,
  communitiesIds.CATALUÑA,
  communitiesIds.GALICIA,
  communitiesIds.PAÍS_VASCO,
  communitiesIds.CEUTA,
  communitiesIds.MELILLA
];
const communitiesExcludedTest = [
  // communitiesIds.ANDALUCIA,
  communitiesIds.ARAGON,
  communitiesIds.ASTURIAS,
  communitiesIds.BALEARES,
  communitiesIds.CANARIAS,
  communitiesIds.CANTABRIA,
  // communitiesIds.CASTILLA_Y_LEÓN,
  communitiesIds.CASTILLA_LA_MANCHA,
  communitiesIds.CATALUÑA,
  communitiesIds.COMUNITAT_VALENCIANA,
  communitiesIds.EXTREMADURA,
  communitiesIds.GALICIA,
  communitiesIds.COMUNIDAD_DE_MADRID,
  communitiesIds.REGIÓN_DE_MURCIA,
  communitiesIds.COMUNIDAD_FORAL_DE_NAVARRA,
  communitiesIds.PAÍS_VASCO,
  communitiesIds.LA_RIOJA,
  communitiesIds.CEUTA,
  communitiesIds.MELILLA
];
// TODO: cambiar cuando haya datos de estas elecciones
export const excludedGrandParentIds = communitiesExcluded;
// export const excludedGrandParentIds = [];

// Configuración sólo necesaria si la comunidad es la provincia como en el caso de Madrid

export const parentIdProvince = '28';

export const grandPaIdCommunity = 'R13';

// Entorno
export const isPreEnv = process.env.REACT_APP_STAGING;

export const PROPERTIES_JSON = () => {
  const host = window.location.hostname;
  const local = host.indexOf('localhost') !== -1;
  const queryCache = `?q=${new Date().getTime()}`;
  if (local) {
    return electionsJson;
  }
  if (isPreEnv) {
    return `/${electionsPathJson}-pre/elections.json${queryCache || ''}`;
  }
  return `/${electionsPathJson}/elections.json${queryCache || ''}`;
};

// partiesSimulator_json
export const PARTIES_SIMULATOR_JSON = () => {
  const host = window.location.hostname;
  // const local = host.indexOf('localhost') !== -1;
  // const queryCache = `?q=${new Date().getTime()}`;
  // if (local) {
  return partiesSimulatorJson;
  // }
  // if (isPreEnv) {
  //   return `/${electionsPathJson}-pre/partiesSimulator.json${queryCache || ''}`;
  // }
  // return `/${electionsPathJson}/partiesSimulator.json${queryCache || ''}`;
};

// Titulares cintillo

export const SUMA_BLOQUE_TITLE = {
  ondacero: 'Izquierda VS. Derecha',
  lasexta: 'Izquierda VS. Derecha'
};
